import { useNavigate } from "react-router-dom";
import { APP_RETIREMENT_URLS, ERROR_MESSAGES } from "../../../const/AppConst";
import StickButtonsBloc from "../../common/StickButtonsBloc";
import useAppState from "../../../context/AppContext";
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import InfoSignatureConfirmTemplate, { SignatureFormData } from "../../../components/info-signature-template/InfoSignatureConfirmTemplate";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { AxiosError } from "axios";
import { signPropositionContract } from "../../../services/CustomerApiService";
import LoaderModal from "../../../modals/common/LoaderModal";
import MgpMessage from "../../../elements/MgpMessage/MgpMessage";


export default function REInfoSignatureConfirmBloc() {

    const navigate = useNavigate();
    const {
      state: { proposition, jwtToken, sessionUid },
      dispatch,
    } = useAppState();

     const [attempts, setAttempts ] = useState<number>(3);
     const [errorMsg, setErrorMsg] = useState<string | null>();
     const [loading, setLoading] = useState<boolean>(false);

    const validationSchema = Yup.object().shape({
        validationCode: Yup.string()
        .required(ERROR_MESSAGES.requiredMsg)
        .matches(/^\d+$/, ERROR_MESSAGES.invalidMsg )
        .max(6, ERROR_MESSAGES.invalidMsg)
        .min(6, ERROR_MESSAGES.invalidMsg),
        });
    
      const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm<SignatureFormData>({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
          validationCode: '',
        },
        resolver: yupResolver(validationSchema),
      });

      const onNextAction = async (data: SignatureFormData) => {
        setErrorMsg(null);
        setLoading(true)
        try {
          const token = jwtToken!.accessToken;
          const body = {sessionUid, smsCode: data.validationCode};
     
          const res =  await signPropositionContract(token, proposition!.propositionId, body);
    
          setLoading(false);

          dispatch({type: 'LIST_SIGNED_DOCUMENT', signedDocument: res.data});

          const nextUrl = APP_RETIREMENT_URLS.infoSignatureDonePage
          dispatch({type: 'NEXT_INFO_STEP', path: nextUrl});
          navigate({
              pathname: nextUrl,
              search: `?id=${proposition!.propositionId}`,
          });
         
        } catch (error) {
          //check error code
          if (attempts > 0) {
            setAttempts(attempts -1 )
          } 
          setLoading(false);
          const err = error as AxiosError;
          console.log(err);
          if(err.response && err.response.status === 401) {
            setErrorMsg("Erreur: Code d'authentification invalide");
          } else {
            setErrorMsg("Une erreur technique est survenue ");
          }
        }
      }

      return (
        <div className="">
          <div className="">
            <h2 className="card-title bleu">Veuillez saisir le code d'authentification reçu par sms</h2>
           <InfoSignatureConfirmTemplate register={register} errors={errors} attempts={attempts} setAttempts={setAttempts}/>
          </div>

          {loading && <LoaderModal hasMessage={true}/>}
          <div>
            {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
          </div>    

          {attempts > 0 ? <StickButtonsBloc nextButtonName='Signer' showNextButton={true} showPreviousButton={false} nextAction={handleSubmit(onNextAction)}/> : <StickButtonsBloc disabledNextButton={true} nextButtonName='Signer' showNextButton={true} showPreviousButton={false} nextAction={handleSubmit(onNextAction)}/>}
        </div>
      )
}